import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);

  intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // Déconnexion automatique sur 401 (token expiré ou invalide).
        // Exclusions : appels d'authentification et chargement des libellés (non bloquant),
        // pour qu'un 401 sur ces appels n'interrompe pas la connexion en cours.
        const isBackgroundCall =
          request.url.includes('/api/auth/') || request.url.includes('/services/get-column-names');
        if (err.status === 401 && !isBackgroundCall && sessionStorage.getItem('auth_token')) {
          this.authenticationService.logout();
        }

        // Rethrow the original HttpErrorResponse so callers can inspect status/body
        // (e.g. 400 vs 403 vs 429) instead of a flat string.
        return throwError(() => err);
      })
    );
  }
}
